export default {"src":"/_next/static/media/homepageBg.7b62eb0b.svg","height":1728,"width":1728,"blurWidth":0,"blurHeight":0};